import { GetterTree } from 'vuex';
import { ImporterHelper } from '@/dealroom/create-page/importer/helpers/importer.helper';
import { ImportGoogleDocsHelper } from '@/dealroom/google-docs/helpers/import-google-docs.helper';
import { EUpdateGoogleDocsGetter } from '@/dealroom/google-docs/store/update-google-docs.constants';
import { IUpdateGoogleDocsState } from '@/dealroom/google-docs/store/update-google-docs.types';
import { RootState } from '@/store/store';
import { IImportProgress } from '@/dealroom/create-page/importer/types/import-progress';
import { translate } from '@/helpers/translation.helper';
import { EImportStatus } from '@/dealroom/create-page/importer/types/enums/import-status';
import { IDocumentPage } from '@/types/document-page';

export const getters: GetterTree<IUpdateGoogleDocsState, RootState> = {
  [EUpdateGoogleDocsGetter.Progress](state: IUpdateGoogleDocsState): IImportProgress {
    const {
      pageCount,
      error,
      importedPages,
    }: { pageCount: number; error: string; importedPages: IDocumentPage[] } = state;
    if (error) {
      return {
        message: error,
        percentage: 100,
        status: EImportStatus.Error,
      };
    }
    const importedPageCount: number = importedPages.length;
    if (ImportGoogleDocsHelper.templateUploaded(pageCount, importedPageCount)) {
      return {
        message: translate('importing-google-document').toString(),
        percentage: 25,
        status: EImportStatus.Importing,
      };
    }
    if (ImportGoogleDocsHelper.recievedPageCount(pageCount, importedPageCount)) {
      return {
        message: translate('initializing-page-import').toString(),
        percentage: 50,
        status: EImportStatus.Importing,
      };
    }
    if (ImportGoogleDocsHelper.completed(pageCount, importedPageCount)) {
      return {
        message: translate('completed').toString(),
        percentage: 100,
        status: EImportStatus.Completed,
      };
    }
    return {
      message: `${translate('importing-pages').toString()} (${importedPageCount}/${pageCount})`,
      percentage: 50 + ImporterHelper.pagePercentage(pageCount, importedPageCount, 50),
      status: EImportStatus.Importing,
    };
  },
};
